export default __webpack_public_path__ + "static/media/ProCal.44cd9a94.svg";